import { Box, TextField } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Address } from '../../types';
import './AddressForm.scss';

type Props = {
	address?: Address;
	// eslint-disable-next-line no-unused-vars
	onChange: (address: Address) => void;
};

type InputName = 'street' | 'postCode' | 'postArea';

const AddressForm = observer(
	class AddressForm extends React.Component<Props> {
		address: Address = {
			street: '',
			postCode: '',
			postArea: '',
		};

		constructor(props: Props) {
			super(props);

			makeObservable(this, {
				address: observable,
				handleInputChange: action,
				init: action,
			});
		}

		componentDidMount() {
			this.init();
		}

		componentDidUpdate(prevProps: Readonly<Props>): void {
			if (prevProps.address !== this.props.address) {
				this.init();
			}
		}

		init() {
			if (this.props.address) {
				this.address = { ...this.props.address };
			}
		}

		handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
			this.address[event.target.name as InputName] = event.target.value;
			this.props.onChange(this.address);
		};

		render() {
			return (
				<div className="AddressForm">
					<TextField
						autoComplete="street-address"
						fullWidth
						label="Adresse"
						margin="normal"
						name="street"
						onChange={this.handleInputChange}
						required
						value={this.address.street}
						variant="filled"
					/>
					<Box display="flex" marginTop="-8px">
						<TextField
							autoComplete="postal-code"
							label="Postnummer"
							margin="normal"
							name="postCode"
							onChange={this.handleInputChange}
							required
							value={this.address.postCode}
							variant="filled"
						/>
						<TextField
							autoComplete="address-level2"
							label="Poststed"
							margin="normal"
							name="postArea"
							onChange={this.handleInputChange}
							required
							value={this.address.postArea}
							variant="filled"
						/>
					</Box>
				</div>
			);
		}
	}
);

export default AddressForm;
